export const DEFAULT_COUNTRY_CODE = "+47";

export const BREAKPOINT_TWOTABS = 928;
export const BREAKPOINT_ONETAB = 768;
